import {reduxForm, Field, formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import {changeDate, changeOutletShift, exportShiftRequest} from 'actions/reports/shifts'
import moment from 'moment'
import styles from './ActionBar.css'
import OutletModal from 'components/Fields/ReduxForm/OutletModal'
import * as mpReportsShifts from 'mixpanel/reports/shifts'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  render () {
    const {outlets, showModalOutletMobileState} = this.props

    return (
      <div>
        <div className={styles.wrapper}>
          <MenuTitle menuTitle='Shift' />
          { !isFullSiteMode() &&
            <div className='col-md-6 col-lg-6 visible-md visible-lg no-padding export-shift'>
              <div className='pull-right'>
                <a className='btn btn-primary btn-export' onClick={this._onClickExportButton}>Export</a>
              </div>
            </div>
          }
          <div style={{paddingTop: '20px'}}>
            <div className='row'>
              <div className='col-sm-12 col-xs-12 col-md-8 col-lg-8'>
                <div className={`form-group pull-left visible-md visible-lg no-margin ng-scope ${styles['form-group']}`}>
                  <Field
                    component={DropdownOutlet}
                    outlets={outlets}
                    onChangeOutletIds={this._onChangeOutlet}
                    name='outlet'
                    allOutletOption
                  />
                </div>
                <div className={`form-group no-margin`}>
                  <Field
                    component={DropdownCalendar}
                    name='date'
                    onChange={this._onChangeDate}
                    updateServerOnChange
                  />
                </div>
              </div>
              <Field
                component={OutletModal}
                name='outlet'
                outlets={outlets || []}
                onChangeOutletIds={this._onChangeOutlet}
                allOutletOption
                show={showModalOutletMobileState}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onChangeOutlet = (outletIds) => {
    const {isMobile} = this.props
    let {date: {startDate, endDate}} = this.props.search
    mpReportsShifts.reportsShiftsChangeFilter({
      outletIds,
      startDate,
      endDate
    })
    this.props.dispatch(changeOutletShift(outletIds, startDate, endDate, isMobile))
  };

  _onChangeDate = ({startDate, endDate}) => {
    const {isMobile, search: {outlet}} = this.props
    mpReportsShifts.reportsShiftsChangeFilter({
      outletIds: outlet,
      startDate,
      endDate
    })
    this.props.dispatch(changeDate(startDate, endDate, isMobile))
  };

  _onClickExportButton = () => {
    let {date: {startDate, endDate}, outlet} = this.props.search
    let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
    let filename = 'Report Shifts - ' + dateLabel

    this.props.dispatch(exportShiftRequest({
      start: startDate.format('D/M/YYYY'),
      end: endDate.format('D/M/YYYY')
    }, filename, outlet[0]))
  }
}

const mapForm = {
  form: 'search'
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  return {
    outlets: state.reports.shifts.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ActionBar/ActionBar.js